import {useState} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {Box, Tab, Tabs, TabsTypeMap, TextField} from '@material-ui/core';
import {PhoneFormatCustom, TextBox} from '../../Core/UI';
import API from '../../APIs/API';
import RootStore from '../../Core/mobx/RootStore';

const defaultMessages = {
    phone(link: string) {
        return `Please follow this link to verify your information with Amplify: ${link}`;
    },
    email(link: string) {
        return [
            `<div style="width:100%; text-align:center">`,
            `<img width="50px" height="50px" src="data:image/png;base64, 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" />`,
            `</div>`,
            `<div style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;">`,
            `<p>Great job on starting your life insurance application to protect your family and your financial future! Please verify your information so we can complete and submit your application in order to help you secure the best rate.</p><p><a href="${link}">Verify My Information</a></p>`,
            `</div>`,
        ].join('\n');
    },
};

const styles = (theme: any) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const dialogStyles = {
    content: {
        minWidth: 450,
        paddingTop: 0,
    },
    buttonContainer: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'center',
    },
};

const config: any = {
    consent: {
        heading: 'Send consent link by email or SMS message',
        successSmsMsg: 'Consent SMS message has been sent',
        bodyTxt: 'Customer will receive this consent link',
        failureSmsMsg: 'Failed to send consent email',
        successEmailMsg: 'Consent email has been sent',
        failureEmailMsg: 'Failed to send consent email',
    },
    verify: {
        heading: 'Send verify link by email or SMS message',
        successSmsMsg: 'Verification SMS message has been sent',
        bodyTxt: 'Customer will receive this verification link',
        failureSmsMsg: 'Failed to send verification email',
        successEmailMsg: 'Verification email has been sent',
        failureEmailMsg: 'Failed to send verification email',
    },
};

// @ts-ignore
const DialogTitle = withStyles(styles)((props) => {
    // @ts-ignore
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

function TabPanel(props: any) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other} // eslint-disable-line react/jsx-props-no-spreading
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const RxDialog = ({open, onClose, link, email, setEmail, phone, setPhone, type}: any) => {
    const [value, setValue] = useState(0);

    const handleChange = (
        _event: Parameters<NonNullable<TabsTypeMap['props']['onChange']>>[0],
        newValue: Parameters<NonNullable<TabsTypeMap['props']['onChange']>>[1],
    ) => {
        setValue(newValue);
    };

    if (phone != null) {
        phone = phone.replace(/[^0-9]/g, '');
        phone = phone.slice(phone.length - 10);
    }

    const SendSMS = async () => {
        try {
            const resp = await API.Call<{status: string}>('/sms', 'POST', {
                phone: `+1${phone}`,
                message: defaultMessages.phone(link),
            });
            if (resp?.status !== 'success') {
                throw new Error('Sms send failed');
            }
            type === 'verify' && RedirectToUserForm();
            RootStore.uiStore.showSnackbar(config[type].successSmsMsg, 'success');
        } catch (error) {
            RootStore.uiStore.showSnackbar(config[type].failureSmsMsg, 'error');
        }

        onClose();
    };

    const SendEmail = async () => {
        try {
            const resp = await API.Call<{status: string}>('/email', 'POST', {
                type: 'html',
                to: email,
                subject: 'Verify Your Information',
                content: defaultMessages.email(link),
            });

            if (resp?.status !== 'ok') {
                throw new Error('Email send failed');
            }

            RootStore.uiStore.showSnackbar(config[type].successEmailMsg, 'success');
            type === 'verify' && RedirectToUserForm();
        } catch (error) {
            RootStore.uiStore.showSnackbar(config[type].failureEmailMsg, 'error');
        }

        onClose();
    };

    const RedirectToUserForm = () => {
        const {parameterStore} = RootStore.agentPortalStore;
        const formId = parameterStore?.formid;

        const contact = parameterStore.approval?.emailAddress;
        window.history.replaceState(null, '', `/agent/form/${contact}/${formId}`);
    };

    return (
        <Dialog onClose={onClose} open={open}>
            {/*
            // @ts-ignore */}
            <DialogTitle onClose={onClose}>{config[type].heading}</DialogTitle>
            <DialogContent dividers style={dialogStyles.content}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="simple tabs example"
                >
                    <Tab label="Email" {...a11yProps(0)} />
                    <Tab label="Sms" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <div>
                        {config[type].bodyTxt}
                        <br></br>{' '}
                        <a href={link} target="_blank">
                            {link}
                        </a>
                    </div>
                    <div>
                        <TextField
                            label="Email"
                            type="email"
                            variant="outlined"
                            value={email}
                            placeholder={'example@mail.com'}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{width: '100%', marginTop: 5}}
                        />
                    </div>
                    <div style={dialogStyles.buttonContainer}>
                        <Button autoFocus disabled={!email} onClick={SendEmail} color="primary" variant="contained">
                            Send an email message
                        </Button>
                    </div>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <div>
                        {config[type].bodyTxt}
                        <br></br>{' '}
                        <a href={link} target="_blank">
                            {link}
                        </a>
                    </div>
                    <div>
                        <TextBox
                            label="Phone number"
                            variant="outlined"
                            value={phone}
                            onChange={setPhone}
                            placeholder={'(323) 232-3123'}
                            style={{width: '100%', marginTop: 5}}
                            InputProps={{
                                inputComponent: PhoneFormatCustom,
                            }}
                        />
                    </div>
                    <div style={dialogStyles.buttonContainer}>
                        <Button
                            id="rxDialogSMSSsendButton"
                            disabled={!phone}
                            onClick={SendSMS}
                            color="primary"
                            variant="contained"
                        >
                            Send an SMS message
                        </Button>
                    </div>
                </TabPanel>
            </DialogContent>
        </Dialog>
    );
};

export default RxDialog;
